import * as dataURLToBlob from 'lib/dataURLToBlob';

/**
 * Trigger download of a Blob of data.
 * @param data The data as a Blob
 * @param filename (optional) The suggested filename (browsers may allow users to select a different filename)
 */
export function downloadData(data : Blob, filename? : string) {
    const
        a = document.createElement('a'),
        url = URL.createObjectURL(data);

    a.href = url;
    a.download = filename || 'attachment';

    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
}

// TH 05/05/2017 -- Inspired by http://stackoverflow.com/a/37068362
/**
 * Trigger download of a data URI.
 * @deprcated Data URIs have length restrictions on some browsers (notably Chrome).
 * For more reliable support of large data, use `downloadData` instead.
 * @param dataUri The data to download as a data URI
 * @param filename (optional) The suggested filename (browsers may allow users to select a different filename)
 */
export function downloadDataUri(dataUri : string, filename? : string) {
    const a = document.createElement('a');

    a.href = dataUri;
    a.target = '_blank';
    a.download = filename || 'attachment';

    document.body.appendChild(a);
    a.click();

    // TH 05/09/2017 -- Alternative routine for firing the click event.
    // Might have better browser coverage?
    // TODO -- Cross-browser testing.
    //
    // const evt = document.createEvent('Event');
    // evt.initEvent('click', true, true);
    // a.dispatchEvent(evt);

    document.body.removeChild(a);
}



// WEBPACK FOOTER //
// ./apps/common/services/downloadData.ts